import { render, staticRenderFns } from "./VueSwitch.vue?vue&type=template&id=5513e9f6&scoped=true"
import script from "./VueSwitch.vue?vue&type=script&lang=js"
export * from "./VueSwitch.vue?vue&type=script&lang=js"
import style0 from "./VueSwitch.vue?vue&type=style&index=0&id=5513e9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513e9f6",
  null
  
)

export default component.exports